// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OawD","label":"styles_label__2-rzk"};